import { Methods } from "@newview/infrastructure";
import {NewviewOaBaseApi} from "./NewviewOaBaseApi";


export class ContractPaymentApi extends NewviewOaBaseApi {
  savesTableData(tableId: any, devProd: any, datas: any[]) {
      throw new Error("Method not implemented.");
  }

  public get ControllerName(): any {
    return 'contractPayment'
  }

}